(function () {

  const WK_CONFIG = {

    // =========================================================

    // STANDARDVERSAND

    // Alle Artikel <= 70 cm

    // =========================================================

    standard: {

      name: "Standardversand",

      packages: [

        {

          key: "mini",

          name: "Paket Mini",

          attributeName: "Paket Mini",

          capacity: 11

        },

        {

          key: "small",

          name: "Paket Klein",

          attributeName: "Paket Klein",

          capacity: 70

        },

        {

          key: "medium",

          name: "Paket Mittel",

          attributeName: "Paket Mittel",

          capacity: 144

        },

        {

          key: "large",

          name: "Paket Groß",

          attributeName: "Paket Groß",

          capacity: 192

        }

      ],

      maxPackages: 5,

      halfPalletCapacity: 1056,

      palletCapacity: 2112

    },

    // =========================================================

    // SPERRGUTVERSAND

    // Mindestens ein Artikel >= 71 cm

    // =========================================================

    oversized: {

      name: "Sperrgutversand",

      packages: [

        {

          key: "oversized",

          name: "Paket Sperrgut",

          attributeName: "Paket Sperrgut",

          capacity: 126

        }

      ],

      maxPackages: 4,

      halfPalletCapacity: 1056,

      palletCapacity: 2112

    },

    // =========================================================

    // VERSANDPREISE

    // =========================================================

    prices: {

      package: 6.95,

      halfPallet: 34.95,

      pallet: 69.95

    },

    // =========================================================

    // WOCHENRHYTHMUS

    // =========================================================

    //

    // Donnerstag 06:00 Uhr:

    // Bestellschluss

    //

    // Dienstag:

    // Wareneingang

    //

    // Mittwoch:

    // Übergabe an Paketdienst / Spedition

    //

    // =========================================================

    cutoffDay: 4,

    cutoffHour: 6,

    cutoffMinute: 0,

    // =========================================================

    // ANZAHL SICHTBARER LIEFERWOCHEN

    // =========================================================

    deliveryWeeks: 6,

    // =========================================================

    // ERSTER ERLAUBTER VERSANDTERMIN

    // =========================================================

    firstShippingDate: "2026-09-02",

    // =========================================================

    // LETZTER ERLAUBTER VERSANDTERMIN

    // =========================================================

    lastShippingDate: "2026-10-28"

  };

  // =========================================================

  // ALTE ORDER-NOTE-MARKER

  // Werden nur noch zum Bereinigen alter Warenkörbe benötigt.

  // Neue Notizen enthalten diese Marker NICHT mehr.

  // =========================================================

  const WK_NOTE_START =

    "----- WK VERSANDINFORMATIONEN -----";

  const WK_NOTE_END =

    "----- ENDE WK VERSANDINFORMATIONEN -----";

  // =========================================================

  // FORMATIERUNG

  // =========================================================

  function formatMoney(value) {

    return Number(value).toLocaleString("de-DE", {

      style: "currency",

      currency: "EUR"

    });

  }

  function formatShortDate(date) {

    return date.toLocaleDateString("de-DE", {

      weekday: "short",

      day: "2-digit",

      month: "2-digit"

    });

  }

  function formatLongDate(date) {

    return date.toLocaleDateString("de-DE", {

      weekday: "long",

      day: "2-digit",

      month: "2-digit",

      year: "numeric"

    });

  }

  function escapeHtmlAttribute(value) {

    return String(value)

      .replace(/&/g, "&amp;")

      .replace(/"/g, "&quot;")

      .replace(/\</g, "&lt;")

      .replace(/>/g, "&gt;");

  }

  // =========================================================

  // LIQUID-DATEN LESEN

  // =========================================================

  function readCartShippingData() {

    const el =

      document.querySelector(

        "#wk-liefermodul-data"

      );

    if (!el) {

      return null;

    }

    try {

      return JSON.parse(

        el.textContent

      );

    } catch (error) {

      console.warn(

        "WK Liefermodul JSON Fehler",

        error

      );

      return null;

    }

  }

  // =========================================================

  // SHOPIFY CART LADEN

  // =========================================================

  async function fetchFreshCartData() {

    const liquidData =

      readCartShippingData();

    if (

      !liquidData ||

      !liquidData.items

    ) {

      return null;

    }

    try {

      const response =

        await fetch(

          "/cart.js",

          {

            method: "GET",

            headers: {

              Accept:

                "application/json"

            }

          }

        );

      if (!response.ok) {

        return {

          items:

            liquidData.items || [],

          attributes:

            {},

          note:

            ""

        };

      }

      const cart =

        await response.json();

      const items =

        liquidData.items

          .map(function (liquidItem) {

            const cartItem =

              cart.items.find(

                function (item) {

                  return (

                    Number(item.variant_id) ===

                    Number(liquidItem.variant_id)

                  );

                }

              );

            return {

              variant_id:

                liquidItem.variant_id,

              quantity:

                cartItem

                  ? Number(

                      cartItem.quantity || 0

                    )

                  : Number(

                      liquidItem.quantity || 0

                    ),

              /*

               * weight_kg enthält das

               * Volumengewicht pro Stück.

               */

              weight_kg:

                Number(

                  liquidItem.weight_kg || 0

                ),

              /*

               * <= 70 cm = Standard

               * >= 71 cm = Sperrgut

               */

              height_cm:

                Number(

                  liquidItem.height_cm || 0

                ),

              /*

               * Varianten-Metafeld:

               * custom.liefertermin_sofort_1_3_werktage

               */

              immediate_delivery_1_3_days:

                liquidItem.immediate_delivery_1_3_days === true ||

                String(liquidItem.immediate_delivery_1_3_days).toLowerCase() === "true"

            };

          })

          .filter(function (item) {

            return (

              item.quantity > 0

            );

          });

      return {

        items:

          items,

        attributes:

          cart.attributes || {},

        note:

          cart.note || ""

      };

    } catch (error) {

      console.warn(

        "WK Liefermodul Cart Fehler",

        error

      );

      return {

        items:

          liquidData.items || [],

        attributes:

          {},

        note:

          ""

      };

    }

  }

  // =========================================================

  // SOFORT LIEFERBAR (1-3 WERKTAGE)

  // =========================================================

  function isImmediateDeliveryCart(items) {

    return (

      Array.isArray(items) &&

      items.length > 0 &&

      items.every(function (item) {

        return item.immediate_delivery_1_3_days === true;

      })

    );

  }

  function createImmediateDeliveryOption() {
  return {
    kw: "",
    shippingDate: "",
    label:
      '<strong class="wk-delivery-immediate-title">Sofort</strong>  ' +
      '<span class="wk-delivery-immediate-meta">1-3 Werktage</span>',
    backendValue: "1-3 Werktage"
  };
}
  // =========================================================

  // VERSANDMODELL

  // =========================================================

  function determineShippingModel(items) {

    const hasOversizedItem =

      items.some(function (item) {

        return (

          Number(item.height_cm) >= 71

        );

      });

    return hasOversizedItem

      ? WK_CONFIG.oversized

      : WK_CONFIG.standard;

  }

  // =========================================================

  // EINZELNE PRODUKTEINHEITEN

  // =========================================================

  function createIndividualUnits(items) {

    const units = [];

    items.forEach(function (item) {

      const volume =

        Number(

          item.weight_kg || 0

        );

      const quantity =

        Number(

          item.quantity || 0

        );

      for (

        let i = 0;

        i < quantity;

        i++

      ) {

        units.push({

          variant_id:

            item.variant_id,

          volume:

            volume,

          height_cm:

            Number(

              item.height_cm || 0

            )

        });

      }

    });

    /*

     * Größte Einheiten zuerst.

     */

    units.sort(function (a, b) {

      return (

        b.volume -

        a.volume

      );

    });

    return units;

  }

  // =========================================================

  // GESAMTVOLUMEN

  // =========================================================

  function calculateTotalVolume(units) {

    return units.reduce(

      function (sum, unit) {

        return (

          sum +

          Number(unit.volume || 0)

        );

      },

      0

    );

  }

  // =========================================================

  // PAKETKOMBINATIONEN

  // =========================================================

  function generatePackageCombinations(

    packageTypes,

    maxPackages

  ) {

    const combinations = [];

    function build(

      index,

      remainingPackages,

      counts

    ) {

      if (

        index ===

        packageTypes.length

      ) {

        const finalCounts =

          counts.slice();

        let totalPackages = 0;

        let totalCapacity = 0;

        finalCounts.forEach(

          function (

            count,

            packageIndex

          ) {

            totalPackages +=

              count;

            totalCapacity +=

              count *

              packageTypes[

                packageIndex

              ].capacity;

          }

        );

        combinations.push({

          counts:

            finalCounts,

          totalPackages:

            totalPackages,

          capacity:

            totalCapacity

        });

        return;

      }

      for (

        let count = 0;

        count <= remainingPackages;

        count++

      ) {

        counts[index] =

          count;

        build(

          index + 1,

          remainingPackages - count,

          counts

        );

      }

    }

    build(

      0,

      maxPackages,

      new Array(

        packageTypes.length

      ).fill(0)

    );

    return combinations;

  }

  // =========================================================

  // PALETTEN-OBERGRENZE

  // =========================================================

  function calculateGreedyPalletUpperBound(

    units,

    palletCapacity

  ) {

    const remaining = [];

    units.forEach(function (unit) {

      let placed = false;

      for (

        let i = 0;

        i < remaining.length;

        i++

      ) {

        if (

          remaining[i] +

            0.000001 >=

          unit.volume

        ) {

          remaining[i] -=

            unit.volume;

          placed = true;

          break;

        }

      }

      if (!placed) {

        remaining.push(

          palletCapacity -

          unit.volume

        );

      }

    });

    return remaining.length;

  }

  // =========================================================

  // EXAKTE PACKPRÜFUNG

  // =========================================================

  function canPackUnitsIntoBins(

    units,

    binCapacities

  ) {

    if (!units.length) {

      return true;

    }

    if (!binCapacities.length) {

      return false;

    }

    const volumes =

      units

        .map(function (unit) {

          return Number(

            unit.volume || 0

          );

        })

        .sort(function (a, b) {

          return b - a;

        });

    const capacities =

      binCapacities

        .slice()

        .sort(function (a, b) {

          return b - a;

        });

    if (

      volumes[0] >

      capacities[0] +

        0.000001

    ) {

      return false;

    }

    const totalVolume =

      volumes.reduce(

        function (sum, value) {

          return (

            sum +

            value

          );

        },

        0

      );

    const totalCapacity =

      capacities.reduce(

        function (sum, value) {

          return (

            sum +

            value

          );

        },

        0

      );

    if (

      totalVolume >

      totalCapacity +

        0.000001

    ) {

      return false;

    }

    const remaining =

      capacities.slice();

    const memo =

      new Set();

    function search(itemIndex) {

      if (

        itemIndex >=

        volumes.length

      ) {

        return true;

      }

      const volume =

        volumes[itemIndex];

      const stateKey =

        itemIndex +

        "|" +

        remaining

          .slice()

          .sort(function (a, b) {

            return b - a;

          })

          .map(function (value) {

            return value.toFixed(4);

          })

          .join(",");

      if (

        memo.has(

          stateKey

        )

      ) {

        return false;

      }

      const triedRemaining =

        new Set();

      for (

        let binIndex = 0;

        binIndex < remaining.length;

        binIndex++

      ) {

        const freeSpace =

          remaining[binIndex];

        if (

          freeSpace +

            0.000001 <

          volume

        ) {

          continue;

        }

        const symmetryKey =

          freeSpace.toFixed(4);

        if (

          triedRemaining.has(

            symmetryKey

          )

        ) {

          continue;

        }

        triedRemaining.add(

          symmetryKey

        );

        remaining[binIndex] -=

          volume;

        if (

          search(

            itemIndex + 1

          )

        ) {

          return true;

        }

        remaining[binIndex] +=

          volume;

      }

      memo.add(

        stateKey

      );

      return false;

    }

    return search(0);

  }

  // =========================================================

  // FRACHTMITTEL-KAPAZITÄTEN

  // =========================================================

  function createBinCapacities(

    model,

    packageCombination,

    halfPallets,

    pallets

  ) {

    const bins = [];

    for (

      let i = 0;

      i < pallets;

      i++

    ) {

      bins.push(

        model.palletCapacity

      );

    }

    for (

      let i = 0;

      i < halfPallets;

      i++

    ) {

      bins.push(

        model.halfPalletCapacity

      );

    }

    packageCombination

      .counts

      .forEach(

        function (

          count,

          packageIndex

        ) {

          const capacity =

            model.packages[

              packageIndex

            ].capacity;

          for (

            let i = 0;

            i < count;

            i++

          ) {

            bins.push(

              capacity

            );

          }

        }

      );

    return bins;

  }

  // =========================================================

  // BESTE FRACHTKOMBINATION

  // =========================================================

  function findBestFreightCombination(

    units,

    model

  ) {

    if (!units.length) {

      return null;

    }

    const totalVolume =

      calculateTotalVolume(

        units

      );

    const largestUnit =

      units[0].volume;

    if (

      largestUnit >

      model.palletCapacity +

        0.000001

    ) {

      console.warn(

        "WK Liefermodul: Ein einzelner Artikel überschreitet die maximale Palettenkapazität.",

        largestUnit

      );

      return null;

    }

    const packageCombinations =

      generatePackageCombinations(

        model.packages,

        model.maxPackages

      );

    const maxPallets =

      calculateGreedyPalletUpperBound(

        units,

        model.palletCapacity

      );

    let bestOption =

      null;

    for (

      let pallets = 0;

      pallets <= maxPallets;

      pallets++

    ) {

      /*

       * Maximal eine zusätzliche Halbpalette.

       */

      for (

        let halfPallets = 0;

        halfPallets <= 1;

        halfPallets++

      ) {

        packageCombinations.forEach(

          function (

            packageCombination

          ) {

            if (

              pallets === 0 &&

              halfPallets === 0 &&

              packageCombination

                .totalPackages === 0

            ) {

              return;

            }

            const capacity =

              (

                pallets *

                model.palletCapacity

              ) +

              (

                halfPallets *

                model.halfPalletCapacity

              ) +

              packageCombination.capacity;

            if (

              capacity +

                0.000001 <

              totalVolume

            ) {

              return;

            }

            const price =

              (

                pallets *

                WK_CONFIG.prices.pallet

              ) +

              (

                halfPallets *

                WK_CONFIG.prices.halfPallet

              ) +

              (

                packageCombination

                  .totalPackages *

                WK_CONFIG.prices.package

              );

            const roundedPrice =

              Number(

                price.toFixed(2)

              );

            if (

              bestOption &&

              roundedPrice >

                bestOption.price

            ) {

              return;

            }

            const bins =

              createBinCapacities(

                model,

                packageCombination,

                halfPallets,

                pallets

              );

            const fits =

              canPackUnitsIntoBins(

                units,

                bins

              );

            if (!fits) {

              return;

            }

            const option = {

              packageCounts:

                packageCombination

                  .counts.slice(),

              totalPackages:

                packageCombination

                  .totalPackages,

              halfPallets:

                halfPallets,

              pallets:

                pallets,

              capacity:

                capacity,

              price:

                roundedPrice

            };

            if (!bestOption) {

              bestOption =

                option;

              return;

            }

            // =================================================

            // 1. NIEDRIGSTER PREIS

            // =================================================

            if (

              option.price <

              bestOption.price

            ) {

              bestOption =

                option;

              return;

            }

            if (

              option.price >

              bestOption.price

            ) {

              return;

            }

            // =================================================

            // 2. GERINGSTE ÜBERKAPAZITÄT

            // =================================================

            const optionUnused =

              option.capacity -

              totalVolume;

            const bestUnused =

              bestOption.capacity -

              totalVolume;

            if (

              optionUnused <

              bestUnused -

                0.000001

            ) {

              bestOption =

                option;

              return;

            }

            if (

              optionUnused >

              bestUnused +

                0.000001

            ) {

              return;

            }

            // =================================================

            // 3. WENIGSTE FRACHTMITTEL

            // =================================================

            const optionUnits =

              option.totalPackages +

              option.halfPallets +

              option.pallets;

            const bestUnits =

              bestOption.totalPackages +

              bestOption.halfPallets +

              bestOption.pallets;

            if (

              optionUnits <

              bestUnits

            ) {

              bestOption =

                option;

            }

          }

        );

      }

    }

    return bestOption;

  }

  // =========================================================

  // GESAMTE FRACHTBERECHNUNG

  // =========================================================

  function calculateFreight(items) {

    const model =

      determineShippingModel(

        items

      );

    const units =

      createIndividualUnits(

        items

      );

    const totalVolume =

      calculateTotalVolume(

        units

      );

    const option =

      findBestFreightCombination(

        units,

        model

      );

    if (!option) {

      return null;

    }

    const hasPallet =

      option.halfPallets > 0 ||

      option.pallets > 0;

    const hasPackages =

      option.totalPackages > 0;

    let service;

    if (

      hasPallet &&

      hasPackages

    ) {

      service =

        "Spedition + Paketdienst";

    } else if (

      hasPallet

    ) {

      service =

        "Spedition";

    } else {

      service =

        "Paketdienst";

    }

    return {

      modelName:

        model.name,

      packageTypes:

        model.packages,

      totalVolume:

        totalVolume,

      packageCounts:

        option.packageCounts,

      totalPackages:

        option.totalPackages,

      halfPallets:

        option.halfPallets,

      pallets:

        option.pallets,

      capacity:

        option.capacity,

      price:

        option.price,

      service:

        service

    };

  }

  // =========================================================

  // SINGULAR / PLURAL

  // =========================================================

  function pluralizeHalfPallet(count) {

    return count === 1

      ? "Halbpalette"

      : "Halbpaletten";

  }

  function pluralizePallet(count) {

    return count === 1

      ? "Palette"

      : "Paletten";

  }

  function pluralizePackageName(

    packageName,

    count

  ) {

    if (

      count === 1

    ) {

      return packageName;

    }

    switch (

      packageName

    ) {

      case "Paket Mini":

        return "Pakete Mini";

      case "Paket Klein":

        return "Pakete Klein";

      case "Paket Mittel":

        return "Pakete Mittel";

      case "Paket Groß":

        return "Pakete Groß";

      case "Paket Sperrgut":

        return "Pakete Sperrgut";

      default:

        return "Pakete";

    }

  }

  // =========================================================

  // DETAILLIERTE FRACHTBESCHREIBUNG

  // Für Shopify intern und Bestellnotiz.

  // =========================================================

  function createFreightDescription(result) {

    const parts = [];

    if (

      result.pallets > 0

    ) {

      parts.push(

        `${result.pallets} ${pluralizePallet(result.pallets)}`

      );

    }

    if (

      result.halfPallets > 0

    ) {

      parts.push(

        `${result.halfPallets} ${pluralizeHalfPallet(result.halfPallets)}`

      );

    }

    result.packageCounts.forEach(

      function (

        count,

        index

      ) {

        if (

          count <= 0

        ) {

          return;

        }

        const packageType =

          result.packageTypes[

            index

          ];

        parts.push(

          `${count} ${pluralizePackageName(

            packageType.name,

            count

          )}`

        );

      }

    );

    return parts.join(

      " + "

    );

  }

  // =========================================================

  // FRACHTBESCHREIBUNG FRONTEND

  //

  // Hier werden Paketgrößen bewusst NICHT angezeigt.

  //

  // Beispiel:

  // 1 Palette + 3 Pakete

  //

  // statt:

  // 1 Palette + 2 Pakete Groß + 1 Paket Klein

  // =========================================================

  function createFrontendFreightDescription(result) {

    const parts = [];

    if (

      result.pallets > 0

    ) {

      parts.push(

        `${result.pallets} ${pluralizePallet(result.pallets)}`

      );

    }

    if (

      result.halfPallets > 0

    ) {

      parts.push(

        `${result.halfPallets} ${pluralizeHalfPallet(result.halfPallets)}`

      );

    }

    if (

      result.totalPackages > 0

    ) {

      parts.push(

        `${result.totalPackages} ${

          result.totalPackages === 1

            ? "Paket"

            : "Pakete"

        }`

      );

    }

    return parts.join(

      " + "

    );

  }

  // =========================================================

  // PAKETANZAHLEN

  // =========================================================

  function getPackageAttributeCounts(result) {

    const counts = {

      "Paket Mini": 0,

      "Paket Klein": 0,

      "Paket Mittel": 0,

      "Paket Groß": 0,

      "Paket Sperrgut": 0

    };

    result.packageCounts.forEach(

      function (

        count,

        index

      ) {

        const packageType =

          result.packageTypes[

            index

          ];

        if (

          Object.prototype

            .hasOwnProperty.call(

              counts,

              packageType.attributeName

            )

        ) {

          counts[

            packageType.attributeName

          ] = count;

        }

      }

    );

    return counts;

  }

  // =========================================================

  // ISO-KALENDERWOCHE

  // =========================================================

  function getISOWeek(date) {

    const d =

      new Date(

        Date.UTC(

          date.getFullYear(),

          date.getMonth(),

          date.getDate()

        )

      );

    const dayNum =

      d.getUTCDay() || 7;

    d.setUTCDate(

      d.getUTCDate() +

      4 -

      dayNum

    );

    const yearStart =

      new Date(

        Date.UTC(

          d.getUTCFullYear(),

          0,

          1

        )

      );

    return Math.ceil(

      (

        (

          (

            d -

            yearStart

          ) /

          86400000

        ) +

        1

      ) /

      7

    );

  }

  // =========================================================

  // DATUM AUS KONFIGURATION LESEN

  // =========================================================

  function parseConfigDate(

    dateString,

    configName

  ) {

    if (!dateString) {

      return null;

    }

    const match =

      String(dateString).match(

        /^(\d{4})-(\d{2})-(\d{2})$/

      );

    if (!match) {

      console.warn(

        `WK Liefermodul: ${configName} muss im Format YYYY-MM-DD angegeben werden.`,

        dateString

      );

      return null;

    }

    const year =

      Number(match[1]);

    const month =

      Number(match[2]);

    const day =

      Number(match[3]);

    const date =

      new Date(

        year,

        month - 1,

        day,

        0,

        0,

        0,

        0

      );

    if (

      date.getFullYear() !== year ||

      date.getMonth() !== month - 1 ||

      date.getDate() !== day

    ) {

      console.warn(

        `WK Liefermodul: ${configName} ist kein gültiges Datum.`,

        dateString

      );

      return null;

    }

    return date;

  }

  function getFirstAllowedShippingDate() {

    return parseConfigDate(

      WK_CONFIG.firstShippingDate,

      "firstShippingDate"

    );

  }

  function getLastAllowedShippingDate() {

    return parseConfigDate(

      WK_CONFIG.lastShippingDate,

      "lastShippingDate"

    );

  }

  // =========================================================

  // DATUMSGRENZEN PRÜFEN

  // =========================================================

  function validateShippingDateRange() {

    const first =

      getFirstAllowedShippingDate();

    const last =

      getLastAllowedShippingDate();

    if (

      first &&

      last &&

      first > last

    ) {

      console.warn(

        "WK Liefermodul: firstShippingDate liegt nach lastShippingDate."

      );

      return false;

    }

    return true;

  }

  // =========================================================

  // NÄCHSTEN NORMALEN CUTOFF BESTIMMEN

  // =========================================================

  function getNextValidCutoffDate() {

    const now =

      new Date();

    const cutoff =

      new Date(now);

    const daysUntilThursday =

      (

        WK_CONFIG.cutoffDay +

        7 -

        cutoff.getDay()

      ) % 7;

    cutoff.setDate(

      cutoff.getDate() +

      daysUntilThursday

    );

    cutoff.setHours(

      WK_CONFIG.cutoffHour,

      WK_CONFIG.cutoffMinute,

      0,

      0

    );

    /*

     * Donnerstag ab 06:00 Uhr:

     * nächste Bestellrunde.

     */

    if (

      now >= cutoff

    ) {

      cutoff.setDate(

        cutoff.getDate() +

        7

      );

    }

    return cutoff;

  }

  // =========================================================

  // LIEFERZYKLUS

  // =========================================================

  function createDeliveryCycle(cutoff) {

    const goodsArrival =

      new Date(cutoff);

    goodsArrival.setDate(

      goodsArrival.getDate() +

      5

    );

    goodsArrival.setHours(

      0,

      0,

      0,

      0

    );

    const carrierHandover =

      new Date(cutoff);

    carrierHandover.setDate(

      carrierHandover.getDate() +

      6

    );

    carrierHandover.setHours(

      0,

      0,

      0,

      0

    );

    return {

      cutoff:

        new Date(cutoff),

      goodsArrival:

        goodsArrival,

      carrierHandover:

        carrierHandover

    };

  }

  // =========================================================

  // ERSTEN VERFÜGBAREN CUTOFF BERECHNEN

  // =========================================================

  function getFirstDeliveryCutoffDate() {

    const normalCutoff =

      getNextValidCutoffDate();

    const normalCycle =

      createDeliveryCycle(

        normalCutoff

      );

    const firstAllowedShippingDate =

      getFirstAllowedShippingDate();

    if (

      !firstAllowedShippingDate

    ) {

      return normalCutoff;

    }

    if (

      normalCycle.carrierHandover >=

      firstAllowedShippingDate

    ) {

      return normalCutoff;

    }

    const preorderCutoff =

      new Date(

        firstAllowedShippingDate

      );

    preorderCutoff.setDate(

      preorderCutoff.getDate() -

      6

    );

    preorderCutoff.setHours(

      WK_CONFIG.cutoffHour,

      WK_CONFIG.cutoffMinute,

      0,

      0

    );

    return preorderCutoff;

  }

  // =========================================================

  // PRÜFEN, OB SAISON BEREITS VORBEI IST

  // =========================================================

  function isShippingSeasonFinished() {

    const lastAllowedShippingDate =

      getLastAllowedShippingDate();

    if (

      !lastAllowedShippingDate

    ) {

      return false;

    }

    const firstCutoff =

      getFirstDeliveryCutoffDate();

    const firstCycle =

      createDeliveryCycle(

        firstCutoff

      );

    return (

      firstCycle.carrierHandover >

      lastAllowedShippingDate

    );

  }

  // =========================================================

  // LIEFEROPTIONEN

  // =========================================================

  function getDeliveryOptions(service) {

    if (

      !validateShippingDateRange()

    ) {

      return [];

    }

    const firstCutoff =

      getFirstDeliveryCutoffDate();

    const firstAllowedShippingDate =

      getFirstAllowedShippingDate();

    const lastAllowedShippingDate =

      getLastAllowedShippingDate();

    const options = [];

    for (

      let index = 0;

      index < 104;

      index++

    ) {

      const cutoff =

        new Date(

          firstCutoff

        );

      cutoff.setDate(

        cutoff.getDate() +

        (

          index *

          7

        )

      );

      const cycle =

        createDeliveryCycle(

          cutoff

        );

      if (

        firstAllowedShippingDate &&

        cycle.carrierHandover <

          firstAllowedShippingDate

      ) {

        continue;

      }

      if (

        lastAllowedShippingDate &&

        cycle.carrierHandover >

          lastAllowedShippingDate

      ) {

        break;

      }

      const kw =

        getISOWeek(

          cycle.carrierHandover

        );

      const kwValue =

        `KW ${kw}`;

      const shippingDate =

        formatShortDate(

          cycle.carrierHandover

        );

      options.push({

        kw:

          kwValue,

        shippingDate:

          shippingDate,

        /*

         * Kundenansicht.

         *

         * Datum bleibt im Frontend sichtbar.

         */

        label:

          `\<strong>${kwValue}\</strong>` +

          `\<span style="display:block;">` +

          `Versand am ${shippingDate}` +

          `\</span>`,

        /*

         * SHOPIFY-INTERN:

         *

         * Nur noch die KW speichern.

         *

         * Beispiel:

         * KW 36

         *

         * NICHT mehr:

         * KW 36 | Versand am Mi., 02.09. | Paketdienst

         */

        backendValue:

          kwValue

      });

      if (

        options.length >=

        WK_CONFIG.deliveryWeeks

      ) {

        break;

      }

    }

    return options;

  }

  // =========================================================

  // LIEFER-KW AN DEN EINZELNEN WARENKORBPOSITIONEN ANZEIGEN

  // =========================================================

  function updateCartItemDeliveryWeeks(deliveryOptions) {

    const regularOption =

      Array.isArray(deliveryOptions)

        ? deliveryOptions.find(function (option) {

            return (

              option &&

              option.kw &&

              /^KW\s+\d{1,2}$/.test(option.kw)

            );

          })

        : null;

    const week =

      regularOption

        ? regularOption.kw

        : "";

    document

      .querySelectorAll(

        "[data-wk-item-availability][data-wk-immediate='false']"

      )

      .forEach(function (element) {

        const weekElement =

          element.querySelector(

            "[data-wk-item-delivery-week]"

          );

        if (!weekElement) {

          return;

        }

        weekElement.textContent =

          week ||

          "derzeit nicht verfügbar";

      });

  }

  // =========================================================

  // BEREITS GEWÄHLTE OPTION BEIBEHALTEN

  //

  // Unterstützt zusätzlich alte Warenkörbe, in denen noch

  // "KW 36 | Versand am ... | Paketdienst" gespeichert ist.

  // =========================================================

  function determineSelectedDeliveryOption(

    options,

    cartAttributes

  ) {

    if (

      !options ||

      !options.length

    ) {

      return null;

    }

    const storedValue =

      cartAttributes &&

      cartAttributes[

        "Gewünschter Lieferzeitraum"

      ]

        ? String(

            cartAttributes[

              "Gewünschter Lieferzeitraum"

            ]

          )

        : "";

    if (

      storedValue

    ) {

      /*

       * Bei alten gespeicherten Werten alles

       * nach dem ersten " | " ignorieren.

       */

      const storedWeek =

        storedValue.split(" | ")[0];

      const existingOption =

        options.find(

          function (option) {

            return (

              option.backendValue ===

                storedValue ||

              option.kw ===

                storedWeek

            );

          }

        );

      if (

        existingOption

      ) {

        return existingOption;

      }

    }

    return options[0];

  }

  // =========================================================

  // SHOPIFY CART ATTRIBUTES

  // =========================================================

  function createShippingAttributesObject(

    result,

    deliveryOption

  ) {

    const counts =

      getPackageAttributeCounts(

        result

      );

    return {

      Versandverpackung:

        createFreightDescription(

          result

        ),

      Versandart:

        result.modelName,

      Versanddienstleister:

        result.service,

      "Paket Mini":

        String(

          counts[

            "Paket Mini"

          ]

        ),

      "Paket Klein":

        String(

          counts[

            "Paket Klein"

          ]

        ),

      "Paket Mittel":

        String(

          counts[

            "Paket Mittel"

          ]

        ),

      "Paket Groß":

        String(

          counts[

            "Paket Groß"

          ]

        ),

      "Paket Sperrgut":

        String(

          counts[

            "Paket Sperrgut"

          ]

        ),

      Halbpalette:

        String(

          result.halfPallets

        ),

      Palette:

        String(

          result.pallets

        ),

      "Versandkosten berechnet":

        result.price.toFixed(2),

      /*

       * Nur noch Kalenderwoche.

       */

      "Gewünschter Lieferzeitraum":

        deliveryOption

          ? deliveryOption.backendValue

          : "",

      /*

       * Eventuell bereits vorhandene

       * Ship-By-Cart-Attribute entfernen.

       */

      "Ship By": "",

      "Ship by": "",

      "ship by": ""

    };

  }

  // =========================================================

  // BESTELLNOTIZ ERZEUGEN

  //

  // Gewünschtes Ergebnis:

  //

  // KW 36

  // 1 Paket Mini

  //

  // oder:

  //

  // KW 36

  // 1 Palette + 2 Pakete Groß

  //

  // KEINE Marker / Trennstriche.

  // =========================================================

  function createShippingOrderNote(

    result,

    deliveryOption

  ) {

    const calendarWeek =

      deliveryOption &&

      deliveryOption.backendValue

        ? String(

            deliveryOption.backendValue

          ).split(" | ")[0]

        : "Keine KW verfügbar";

    return [

      calendarWeek,

      createFreightDescription(

        result

      )

    ].join("\n");

  }

  // =========================================================

  // ERKENNEN EINER AUTOMATISCH ERZEUGTEN FRACHTZEILE

  // =========================================================

  function isGeneratedFreightNoteLine(line) {

    const parts =

      String(line || "")

        .split(" + ")

        .map(function (part) {

          return part.trim();

        })

        .filter(Boolean);

    if (!parts.length) {

      return false;

    }

    return parts.every(

      function (part) {

        return /^\d+\s+(?:Palette|Paletten|Halbpalette|Halbpaletten|Paket(?:e)?(?:\s+(?:Mini|Klein|Mittel|Groß|Sperrgut))?)$/.test(

          part

        );

      }

    );

  }

  // =========================================================

  // ALTE WK-NOTIZ ENTFERNEN

  //

  // Unterstützt:

  //

  // 1. Alte Variante MIT Trennstrichen.

  //

  // 2. Neue Variante OHNE Trennstriche:

  //

  //    KW 36

  //    1 Paket Mini

  //

  // Dadurch entstehen bei Warenkorbänderungen

  // keine doppelten Einträge.

  // =========================================================

  function removeExistingShippingNoteBlock(note) {

    let text =

      String(

        note || ""

      );

    // ---------------------------------------------------------

    // ALTE VERSION MIT MARKERN ENTFERNEN

    // ---------------------------------------------------------

    while (

      text.indexOf(

        WK_NOTE_START

      ) !== -1

    ) {

      const startIndex =

        text.indexOf(

          WK_NOTE_START

        );

      const endIndex =

        text.indexOf(

          WK_NOTE_END,

          startIndex

        );

      /*

       * Wenn kein Endmarker vorhanden ist,

       * ab Startmarker abschneiden.

       */

      if (

        endIndex === -1

      ) {

        text =

          text.slice(

            0,

            startIndex

          );

        break;

      }

      text =

        (

          text.slice(

            0,

            startIndex

          ) +

          text.slice(

            endIndex +

            WK_NOTE_END.length

          )

        );

    }

    text =

      text.trim();

    if (!text) {

      return "";

    }

    // ---------------------------------------------------------

    // NEUE VERSION OHNE MARKER ERKENNEN

    //

    // KW 36

    // 1 Paket Mini

    // ---------------------------------------------------------

    const lines =

      text.split(

        /\r?\n/

      );

    let freightIndex =

      lines.length - 1;

    /*

     * Leere Zeilen am Ende überspringen.

     */

    while (

      freightIndex >= 0 &&

      !lines[

        freightIndex

      ].trim()

    ) {

      freightIndex--;

    }

    if (

      freightIndex < 0

    ) {

      return "";

    }

    let weekIndex =

      freightIndex - 1;

    /*

     * Eventuelle Leerzeilen zwischen

     * KW und Verpackungsmittel überspringen.

     */

    while (

      weekIndex >= 0 &&

      !lines[

        weekIndex

      ].trim()

    ) {

      weekIndex--;

    }

    if (

      weekIndex >= 0 &&

      (

        /^KW\s+\d{1,2}$/.test(

          lines[

            weekIndex

          ].trim()

        ) ||

        lines[weekIndex].trim() === "1-3 Werktage"

      ) &&

      isGeneratedFreightNoteLine(

        lines[

          freightIndex

        ].trim()

      )

    ) {

      return lines

        .slice(

          0,

          weekIndex

        )

        .join("\n")

        .trim();

    }

    return text;

  }

  // =========================================================

  // KUNDENNOTIZ + AUTOMATISCHE VERSANDNOTIZ

  // =========================================================

  function createMergedOrderNote(

    existingNote,

    result,

    deliveryOption

  ) {

    const customerNote =

      removeExistingShippingNoteBlock(

        existingNote

      );

    const shippingNote =

      createShippingOrderNote(

        result,

        deliveryOption

      );

    /*

     * Falls der Kunde selbst eine Notiz eingegeben hat,

     * bleibt diese erhalten.

     */

    if (

      customerNote

    ) {

      return (

        customerNote +

        "\n\n" +

        shippingNote

      );

    }

    return shippingNote;

  }

  // =========================================================

  // CART-DATEN SPEICHERN

  // =========================================================

  let lastSavedCartSignature =

    null;

  async function saveCartData(

    attributes,

    note

  ) {

    const signature =

      JSON.stringify({

        attributes:

          attributes,

        note:

          note

      });

    /*

     * Identische Updates vermeiden.

     */

    if (

      signature ===

      lastSavedCartSignature

    ) {

      return true;

    }

    try {

      const response =

        await fetch(

          "/cart/update.js",

          {

            method:

              "POST",

            headers: {

              "Content-Type":

                "application/json",

              Accept:

                "application/json"

            },

            body:

              JSON.stringify({

                attributes:

                  attributes,

                note:

                  note

              })

          }

        );

      if (

        !response.ok

      ) {

        console.warn(

          "WK Liefermodul: Cart-Daten konnten nicht gespeichert werden."

        );

        return false;

      }

      lastSavedCartSignature =

        signature;

      return true;

    } catch (error) {

      console.warn(

        "WK Liefermodul: Fehler beim Speichern der Cart-Daten",

        error

      );

      return false;

    }

  }

  // =========================================================

  // VERSTECKTE ATTRIBUTE

  // =========================================================

  function createShippingAttributesHtml(

    result,

    selectedDeliveryOption

  ) {

    const attributes =

      createShippingAttributesObject(

        result,

        selectedDeliveryOption

      );

    return `

      \<div

        id="wk-shipping-attributes"

        style="display:none;"

      >

        ${Object.keys(attributes)

          .map(function (name) {

            return `

              \<input

                type="hidden"

                name="attributes[${escapeHtmlAttribute(name)}]"

                value="${escapeHtmlAttribute(attributes[name])}"

                form="CartPageForm"

              >

            `;

          })

          .join("")}

      \</div>

    `;

  }

  // =========================================================

  // VERSANDKARTE

  // =========================================================

  function createShippingCardHtml(

    result

  ) {

    /*

     * Im Frontend nur Gesamtanzahl

     * der Pakete anzeigen.

     */

    const freightDescription =

      createFrontendFreightDescription(

        result

      );

    return `

      \<div class="wk-card">

        \<h3>

          So wird deine Hecke angeliefert

        \</h3>

        \<div class="wk-shipping-grid">

          \<div class="wk-shipping-row">

            \<span class="wk-shipping-label">

              Frachtmittel:

            \</span>

            \<span class="wk-shipping-value">

              ${freightDescription}

            \</span>

          \</div>

          \<div class="wk-shipping-row">

            \<span class="wk-shipping-label">

              Dienstleister:

            \</span>

            \<span class="wk-shipping-value">

              ${result.service}

            \</span>

          \</div>

          \<div class="wk-shipping-row">

            \<span class="wk-shipping-label">

              Versandkosten:

            \</span>

            \<span class="wk-shipping-value">

              ${formatMoney(result.price)}

            \</span>

          \</div>

        \</div>

        ${

          result.service ===

          "Spedition + Paketdienst"

            ? `

              \<div

                class="wk-shipping-note"

                style="margin-top:12px;"

              >

                \<p>

                  \<strong>Hinweis:\</strong>

                  Deine Bestellung wird in zwei getrennten

                  Sendungen zugestellt. Die Palette wird

                  durch eine Spedition geliefert, die

                  Pakete werden separat durch einen

                  Paketdienst zugestellt.

                \</p>

              \</div>

            `

            : ""

        }

        \<div class="wk-shipping-note">

          \<p>

            Unser intelligentes Versandsystem plant deine

            Heckenlieferung immer zum Bestpreis. Die Berechnung

            der Versandkosten basiert dabei auf dem tatsächlichen

            Volumen deiner Bestellung.

          \</p>

          \<p>

            \<strong>

              Versandpreise:

            \</strong>

          \</p>

          \<p>

            Pro Paket: 6,95 € |

            Pro Halbpalette: 34,95 € |

            Pro Palette: 69,95 €

          \</p>

        \</div>

      \</div>

    `;

  }

  // =========================================================

  // KEINE LIEFERTERMINE VERFÜGBAR

  // =========================================================

  function createNoDeliveryDatesHtml() {

    const lastAllowedShippingDate =

      getLastAllowedShippingDate();

    let text =

      "Aktuell sind keine weiteren Versandtermine freigeschaltet.";

    if (

      lastAllowedShippingDate

    ) {

      text =

        `Der letzte aktuell freigeschaltete Versandtermin war ` +

        `${formatLongDate(lastAllowedShippingDate)}. ` +

        `Neue Liefertermine werden zu einem späteren Zeitpunkt freigeschaltet.`;

    }

    return `

      \<div class="wk-card wk-delivery-card">

        \<h3>

          Aktuell keine Liefertermine verfügbar

        \</h3>

        \<p class="wk-delivery-intro">

          ${text}

        \</p>

      \</div>

    `;

  }

  // =========================================================

  // FEHLER

  // =========================================================

  function createFreightErrorHtml() {

    return `

      \<div class="wk-card">

        \<h3>

          Versand wird berechnet

        \</h3>

        \<div class="wk-shipping-note">

          Für mindestens einen Artikel konnte aktuell

          kein passendes Frachtmittel ermittelt werden.

        \</div>

      \</div>

    `;

  }

  // =========================================================

  // SOFORT-LIEFERTERMIN-KARTE

  // =========================================================

  function createImmediateDeliveryCardHtml() {

    return `

      \<div class="wk-card wk-delivery-card">

        \<h3>Lieferzeit\</h3>

        \<p class="wk-delivery-intro">

          Alle Artikel in deinem Warenkorb sind sofort lieferbar.

        \</p>

        \<div class="wk-selected-delivery">

          \<span class="wk-selected-label">Lieferzeit:\</span>

          \<span class="wk-selected-value">\<strong>1-3 Werktage\</strong>\</span>

          \<div class="wk-selected-note">

            Die reguläre Lieferzeit beträgt

            1-3 Werktage.

          \</div>

        \</div>

      \</div>

    `;

  }

  // =========================================================

  // HINWEISTEXT ZUR AUSGEWÄHLTEN LIEFEROPTION

  // =========================================================

  function createSelectedDeliveryNoteHtml(deliveryOption) {

    if (

      deliveryOption &&

      deliveryOption.backendValue === "1-3 Werktage"

    ) {

      return (

        "Deine Bestellung wird schnellstmöglich versendet. " +

        "Die reguläre Lieferzeit beträgt 1-3 Werktage."

      );

    }



    return (

      "Wir geben deine Pflanzen schnellstmöglich bzw. zum angegeben Liefertermin in den Versand. In deiner Bestellbestätigung kannst du den Liefertermin ebenfalls einsehen"

    );

  }



  // =========================================================

  // LIEFERTERMIN-KARTE

  // =========================================================

  function createDeliveryCardHtml(

    result,

    options,

    selectedDeliveryOption

  ) {

    return `

      \<div class="wk-card wk-delivery-card">

        \<h3>

          Liefertermin wählen

        \</h3>

        \<p class="wk-delivery-intro">

          Wähle hier deinen Wunschliefertermin aus. Falls du Artikel mit verschiedenen Lieferterminen ausgewählt hast, gilt der spätere Termin.

        \</p>

        \<input

          type="hidden"

          name="attributes[Gewünschter Lieferzeitraum]"

          id="wk-selected-delivery-attribute"

          value="${escapeHtmlAttribute(

            selectedDeliveryOption.backendValue

          )}"

          form="CartPageForm"

        >

        \<div class="wk-delivery-list">

          ${options.map(

            function (option) {

              const isSelected =

                option.backendValue ===

                selectedDeliveryOption.backendValue;

              return `

                \<label

                  class="wk-delivery-option-card ${

                    isSelected

                      ? "is-selected"

                      : ""

                  }"

                >

                  \<input

                    type="radio"

                    name="wk-delivery-option"

                    value="${escapeHtmlAttribute(

                      option.backendValue

                    )}"

                    data-label="${escapeHtmlAttribute(

                      option.label

                    )}"

                    ${

                      isSelected

                        ? "checked"

                        : ""

                    }

                  >

                  \<span class="wk-delivery-single-line">

                    ${option.label}

                  \</span>

                \</label>

              `;

            }

          ).join("")}

        \</div>

        \<div class="wk-selected-delivery">

          \<span class="wk-selected-label">

            Ausgewählter Liefertermin:

          \</span>

          \<span

            class="wk-selected-value"

            id="wk-selected-delivery-text"

          >

            ${selectedDeliveryOption.label}

          \</span>

          \<div

            class="wk-selected-note"

            id="wk-selected-delivery-note"

          >

            ${createSelectedDeliveryNoteHtml(

              selectedDeliveryOption

            )}

          \</div>

        \</div>

      \</div>

    `;

  }

  // =========================================================

  // GESAMTES MODUL

  // =========================================================

  function createModuleHtml(

    result,

    options,

    selectedDeliveryOption

  ) {

    return `

      ${createShippingCardHtml(

        result

      )}

      ${createDeliveryCardHtml(

        result,

        options,

        selectedDeliveryOption

      )}

      ${createShippingAttributesHtml(

        result,

        selectedDeliveryOption

      )}

    `;

  }

  // =========================================================

  // LIEFERTERMIN-AUSWAHL

  // =========================================================

  function bindDeliverySelection(

    freight,

    existingCartNote

  ) {

    const hiddenInput =

      document.querySelector(

        "#wk-selected-delivery-attribute"

      );

    const selectedText =

      document.querySelector(

        "#wk-selected-delivery-text"

      );

    const selectedNote =

      document.querySelector(

        "#wk-selected-delivery-note"

      );

    const radios =

      document.querySelectorAll(

        "input[name='wk-delivery-option']"

      );

    let currentCartNote =

      existingCartNote || "";

    radios.forEach(

      function (radio) {

        radio.addEventListener(

          "change",

          async function () {

            document

              .querySelectorAll(

                ".wk-delivery-option-card"

              )

              .forEach(

                function (card) {

                  card.classList.remove(

                    "is-selected"

                  );

                }

              );

            const card =

              radio.closest(

                ".wk-delivery-option-card"

              );

            if (

              card

            ) {

              card.classList.add(

                "is-selected"

              );

            }

            const deliveryValue =

              radio.value;

            if (

              hiddenInput

            ) {

              hiddenInput.value =

                deliveryValue;

            }

            if (

              selectedText

            ) {

              selectedText.innerHTML =

                radio.dataset.label ||

                deliveryValue;

            }

            /*

             * deliveryValue enthält jetzt nur:

             *

             * KW 36

             */

            const deliveryOption = {

              backendValue:

                deliveryValue

            };

            if (

              selectedNote

            ) {

              selectedNote.innerHTML =

                createSelectedDeliveryNoteHtml(

                  deliveryOption

                );

            }

            const attributes =

              createShippingAttributesObject(

                freight,

                deliveryOption

              );

            const mergedOrderNote =

              createMergedOrderNote(

                currentCartNote,

                freight,

                deliveryOption

              );

            const saved =

              await saveCartData(

                attributes,

                mergedOrderNote

              );

            if (

              saved

            ) {

              currentCartNote =

                mergedOrderNote;

            }

          }

        );

      }

    );

  }

  // =========================================================

  // MODUL RENDERN

  // =========================================================

  async function renderShippingModule() {

    const target =

      document.querySelector(

        "#wk-shipping-module"

      );

    if (

      !target

    ) {

      return;

    }

    const data =

      await fetchFreshCartData();

    if (

      !data ||

      !data.items ||

      !data.items.length

    ) {

      target.style.display =

        "none";

      return;

    }

    const freight =

      calculateFreight(

        data.items

      );

    target.style.display =

      "";

    if (

      !freight

    ) {

      target.innerHTML =

        createFreightErrorHtml();

      return;

    }

    const immediateDelivery =

      isImmediateDeliveryCart(

        data.items

      );



    let deliveryOptions =

      getDeliveryOptions(

        freight.service

      );



    updateCartItemDeliveryWeeks(

      deliveryOptions

    );



    /*

     * Wenn alle Varianten sofort lieferbar sind,

     * wird "1-3 Werktage" als zusätzliche Option

     * VOR den regulären KW-Optionen angeboten.

     *

     * Eine bereits gespeicherte KW-Auswahl bleibt

     * durch determineSelectedDeliveryOption erhalten.

     */

    if (immediateDelivery) {

      deliveryOptions = [

        createImmediateDeliveryOption()

      ].concat(deliveryOptions);

    }

    // =======================================================

    // KEINE LIEFERTERMINE MEHR VERFÜGBAR

    // =======================================================

    if (

      !deliveryOptions.length

    ) {

      target.innerHTML =

        `

          ${createShippingCardHtml(

            freight

          )}

          ${createNoDeliveryDatesHtml()}

        `;

      /*

       * Alten Liefertermin bewusst leeren.

       */

      const attributes =

        createShippingAttributesObject(

          freight,

          null

        );

      const mergedOrderNote =

        createMergedOrderNote(

          data.note || "",

          freight,

          null

        );

      await saveCartData(

        attributes,

        mergedOrderNote

      );

      return;

    }

    const selectedDeliveryOption =

      determineSelectedDeliveryOption(

        deliveryOptions,

        data.attributes || {}

      );

    target.innerHTML =

      createModuleHtml(

        freight,

        deliveryOptions,

        selectedDeliveryOption

      );

    bindDeliverySelection(

      freight,

      data.note || ""

    );

    const attributes =

      createShippingAttributesObject(

        freight,

        selectedDeliveryOption

      );

    const mergedOrderNote =

      createMergedOrderNote(

        data.note || "",

        freight,

        selectedDeliveryOption

      );

    await saveCartData(

      attributes,

      mergedOrderNote

    );

  }

  // =========================================================

  // RENDER-TIMER

  // =========================================================

  let wkRenderTimer;

  function scheduleRenderShippingModule(

    delay

  ) {

    clearTimeout(

      wkRenderTimer

    );

    wkRenderTimer =

      setTimeout(

        renderShippingModule,

        delay || 300

      );

  }

  // =========================================================

  // SHOPIFY / THEME EVENTS

  // =========================================================

  document.addEventListener(

    "DOMContentLoaded",

    renderShippingModule

  );

  document.addEventListener(

    "cart:updated",

    renderShippingModule

  );

  document.addEventListener(

    "ajaxCart:updated",

    renderShippingModule

  );

  document.addEventListener(

    "cart:refresh",

    renderShippingModule

  );

  // =========================================================

  // MENGENÄNDERUNGEN

  // =========================================================

  document.addEventListener(

    "change",

    function (event) {

      if (

        event.target.matches(

          "input[name='updates[]']"

        ) ||

        event.target.matches(

          ".js-qty__num"

        ) ||

        event.target.matches(

          "[data-quantity-input]"

        ) ||

        event.target.matches(

          "input[type='number']"

        )

      ) {

        scheduleRenderShippingModule(

          500

        );

        setTimeout(

          renderShippingModule,

          1200

        );

      }

    }

  );

  document.addEventListener(

    "input",

    function (event) {

      if (

        event.target.matches(

          "input[name='updates[]']"

        ) ||

        event.target.matches(

          ".js-qty__num"

        ) ||

        event.target.matches(

          "[data-quantity-input]"

        ) ||

        event.target.matches(

          "input[type='number']"

        )

      ) {

        scheduleRenderShippingModule(

          700

        );

      }

    }

  );

  // =========================================================

  // PLUS / MINUS

  // =========================================================

  document.addEventListener(

    "click",

    function (event) {

      if (

        event.target.closest(

          ".js-qty__adjust"

        ) ||

        event.target.closest(

          "[data-quantity-plus]"

        ) ||

        event.target.closest(

          "[data-quantity-minus]"

        ) ||

        event.target.closest(

          "button[name='plus']"

        ) ||

        event.target.closest(

          "button[name='minus']"

        )

      ) {

        scheduleRenderShippingModule(

          400

        );

        setTimeout(

          renderShippingModule,

          1000

        );

        setTimeout(

          renderShippingModule,

          1800

        );

      }

    }

  );

  // =========================================================

  // AUTOMATISCHER ZEIT-/CUTOFF-WECHSEL

  // =========================================================

  let lastScheduleSignature =

    null;

  function getScheduleSignature() {

    const firstCutoff =

      getFirstDeliveryCutoffDate();

    const firstShipping =

      getFirstAllowedShippingDate();

    const lastShipping =

      getLastAllowedShippingDate();

    return [

      firstCutoff

        ? firstCutoff.getTime()

        : "",

      firstShipping

        ? firstShipping.getTime()

        : "",

      lastShipping

        ? lastShipping.getTime()

        : "",

      isShippingSeasonFinished()

        ? "finished"

        : "active"

    ].join("|");

  }

  function checkScheduleRollover() {

    const signature =

      getScheduleSignature();

    if (

      lastScheduleSignature === null

    ) {

      lastScheduleSignature =

        signature;

      return;

    }

    if (

      signature !==

      lastScheduleSignature

    ) {

      lastScheduleSignature =

        signature;

      renderShippingModule();

    }

  }

  /*

   * Jede Minute prüfen.

   */

  setInterval(

    checkScheduleRollover,

    60000

  );

  // =========================================================

  // INITIALISIERUNG

  // =========================================================

  lastScheduleSignature =

    getScheduleSignature();

  setTimeout(

    renderShippingModule,

    300

  );

  setTimeout(

    renderShippingModule,

    1000

  );

})();